import api from '../api';

export const optionsFetchSuccess = (options) => {
    return {
        type: 'OPTIONS_FETCH_SUCCESS',
        options
    };
};

export function loadOptions() {
    return (dispatch) => {
        return api.getOptions().then(response => {
            dispatch(optionsFetchSuccess(response));
        }).catch(error => {
            throw(error);
        });
    };
}

export function getOption(option_slug) {
    return option_slug;
}



// WEBPACK FOOTER //
// ./src/actions/optionActions.js